<script setup>
import {tvClock, tvWhen} from '~/utils/tvDisplay';

// The next date of a meet, at table size: when, who's going, and room left
const props = defineProps({
  panel: {type: Object, required: true},
});

const meet = computed(() => props.panel.meet);
const full = computed(() => meet.value?.maxAttendees != null && meet.value.going >= meet.value.maxAttendees);
const fill = computed(() => meet.value?.maxAttendees ? Math.min(100, (meet.value.going / meet.value.maxAttendees) * 100) : null);
const spaces = computed(() => meet.value?.maxAttendees != null ? Math.max(0, meet.value.maxAttendees - meet.value.going) : null);
const when = computed(() => {
  if (!meet.value) return '';
  const ends = meet.value.endsAt ? ` – ${tvClock(new Date(meet.value.endsAt))}` : '';
  return tvWhen(meet.value.startsAt) + ends;
});
const room = computed(() => {
  if (full.value) return meet.value.waitlist ? `Full, ${meet.value.waitlist} waiting` : 'Full';
  if (spaces.value != null) return `${spaces.value} ${spaces.value === 1 ? 'space' : 'spaces'} left`;
  return 'Open';
});
</script>

<template>
  <div v-if="meet" class="tv-meet">
    <div class="tv-meet-row">
      <span class="tv-meet-label">Next date</span>
      <span class="tv-meet-value">{{ when }}</span>
    </div>
    <div class="tv-meet-row">
      <span class="tv-meet-label">Going</span>
      <span class="tv-meet-value">
        {{ meet.going }}<template v-if="meet.maxAttendees != null"> of {{ meet.maxAttendees }}</template>
      </span>
      <span v-if="fill != null" class="tv-meet-bar"><span :style="{width: fill + '%'}"/></span>
    </div>
    <div class="tv-meet-row">
      <span class="tv-meet-label">Places</span>
      <span class="tv-meet-value" :class="{'tv-meet-value--full': full}">{{ room }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tv-meet-row {
  display: grid;
  grid-template-columns: 170px auto minmax(0, 1fr);
  align-items: center;
  gap: 20px;
  height: 54px;
  padding: 0 20px;
  border-bottom: 1px solid var(--tv-line);
}

.tv-meet-label {
  font-size: 22px;
  color: var(--tv-muted);
}

.tv-meet-value {
  font-family: var(--tv-display);
  font-weight: 700;
  font-size: 32px;
  color: var(--tv-ink);
  white-space: nowrap;
}

.tv-meet-value--full {
  color: var(--tv-accent-text);
}

.tv-meet-bar {
  height: 12px;
  border-radius: 6px;
  background: var(--tv-chip);
  overflow: hidden;

  span {
    display: block;
    height: 100%;
    border-radius: 6px;
    background: var(--tv-accent);
  }
}
</style>
